import { appConfig } from 'cd-eft/config/AppConfig';
import * as CLEAN from 'cd-eft/_codegen_/openapi-generator/eft-cleaning';
import axios from 'axios';
import { EftAuthAxiosInterceptor } from './EftAuthAxiosInterceptor';
import { UserIdentity } from 'cd-eft/security/UserIdentity';

const apiConfig = new CLEAN.Configuration({ basePath: appConfig.endpoints.eftCleaningApiBasePath });


const axiosInstance = axios.create();

export const HealthCheckControllerApi = new CLEAN.HealthCheckControllerApi(apiConfig, undefined, axiosInstance);
export const ServiceStatusController = new CLEAN.ServiceStatusControllerApi(apiConfig);

// create and activate the EftAuthAxiosInterceptor
const __eftAuthAxiosInterceptor = new EftAuthAxiosInterceptor(axiosInstance, UserIdentity);
__eftAuthAxiosInterceptor.activate();

// console.log('!!!! EFT-CLEAN API INITIALIZED !!!!');
